import { ReportSettings } from 'models';
import { ADD_DATA, ADD_OR_UPDATE_DATA, RESET_REPORTS } from './actionTypes';

// Utils
const toReportModel = data => {
  const {
    created_at,
    format,
    id,
    name,
    setup_properties,
    type,
    updated_at
  } = data;
  const { aggregations, filters, group_by, selectors } = setup_properties;
  return new ReportSettings({
    id,
    name,
    type,
    createdOn: created_at,
    updatedOn: updated_at,
    format,
    filters,
    groupsZone: group_by,
    othersZone: selectors,
    aggregatesZone: aggregations
  });
};

const initialState = {
  data: []
};

const reports = (state = initialState, action) => {
  switch (action.type) {
    case ADD_DATA:
      return {
        ...state,
        data: [...state.data, toReportModel(action.payload.data)]
      };

    case ADD_OR_UPDATE_DATA:
      return {
        ...state
      };

    case RESET_REPORTS:
      return initialState;

    default:
      return state;
  }
};

export default reports;



// WEBPACK FOOTER //
// ./src/store/metaData/reports/reducer.js